import { render, staticRenderFns } from "./NotifiedPeopleHealth.vue?vue&type=template&id=1532d700"
import script from "./NotifiedPeopleHealth.vue?vue&type=script&lang=js"
export * from "./NotifiedPeopleHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports